import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const AdLimit = ({packages}) => {
  const text = config.registrationForm.package.adLimit
  return <tr>
    <td>{text[0]} <strong>{text[1]}</strong> {text[2]}</td>
    {
      packages.map(item => <td key={item.id}>{Number(item.adLimit)}</td>)
    }
  </tr>
}

AdLimit.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    adLimit: PropTypes.number
  })).isRequired
}

AdLimit.defaultProps = {
  packages: []
}
